import { Outlet } from 'react-router-dom';
import { LanguageSelector } from '../LanguageSelector';
import { HoneycombBackground } from './HoneycombBackground';

export const AuthPage = () => {
  return (
    <div className="w-screen min-h-screen flex justify-center items-center bg-transparent relative overflow-x-hidden overflow-y-auto z-10 py-8">
      <HoneycombBackground />
      <div className="bg-white/98 p-8 rounded-xl shadow-2xl w-full max-w-4xl relative z-10 backdrop-blur-md border border-white/20 before:content-[''] before:absolute before:-top-1/2 before:-left-1/2 before:w-[200%] before:h-[200%] before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent before:rotate-45 before:animate-[shine_3s_infinite] before:-z-10">
        <Outlet />
      </div>
      <LanguageSelector />
    </div>
  );
}; 